module.exports = __webpack_public_path__ + "img/whats-new-9_cn.2809c3f.jpg";